import { render, staticRenderFns } from "./HatcheryAnalysisTable.vue?vue&type=template&id=60aed19a&scoped=true&"
import script from "./HatcheryAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./HatcheryAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./HatcheryAnalysisTable.vue?vue&type=style&index=0&id=60aed19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aed19a",
  null
  
)

export default component.exports